export class ResetEnvironmentPayload {}